export default __webpack_public_path__ + "static/media/wave.4de45846.png";